// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__a0bqM","Main_article":"Main_Main_article__s_yVT"};